<loader *ngIf="showLoader"></loader>
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body p-0">
                <div class="container-fluid card-request-form-section">
                    <div class="row">
                        <div class="col-md-6 order-1 order-md-1 text-left">
                            <div class="xplorer-image-wrapper">
                                <img src="assets/images/smartfx-portal-assets/Xplorer.png" class="xplorer-bg img-fluid"  />
                                <img src="assets/images/smartfx-portal-assets/xplorer-card.png" class="xplorer-card img-fluid" />
                            </div>
                        </div>

                        <!-- Text column -->
                        <div class="col-md-6 order-2 order-md-2 text-md-start registration-form">
                            <div class="form-box">

                                <div class="form-container">
                                    <div class="row" *ngIf="explorerStataData?.registrationStatus == 'NOT_REGISTERED'">
                                        <div class="col-12">
                                            <h2 class="reg-form-heading"><!-- Exclusive Invite Program -->&nbsp;</h2>
                                            <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">

                                                <!-- First Row: Full Name and Profession -->
                                                <div class="row">
                                                    <!-- Full Name -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="fullName">Full Name</label>
                                                            <input id="fullName" type="text" formControlName="fullName"
                                                                class="form-control" placeholder="Enter your full name" [(ngModel)]="requestXplorerRegistration.fullName" />
                                                            <div *ngIf="fullName.invalid && (fullName.dirty || fullName.touched)"
                                                                class="error">
                                                                Full Name is required.
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Profession -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="profession">Profession</label>
                                                            <select id="profession" formControlName="profession" [(ngModel)]="requestXplorerRegistration.profession"
                                                                class="form-control" (change)="onProfessionChange()">
                                                                <option value="">Select Profession</option>
                                                                <option value="CXO">CXO</option>
                                                                <option value="Corporate">Corporate</option>
                                                                <option value="Creators">Creators</option>
                                                            </select>
                                                            <div *ngIf="profession.invalid && (profession.dirty || profession.touched)"
                                                                class="error">
                                                                Profession is required.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Conditional Fields based on Profession selection -->
                                                <div *ngIf="isOption1">
                                                    <div class="row">
                                                        <!-- Company Name and Designation in same row -->
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="companyName">Company Name</label>
                                                                <input id="companyName" type="text"
                                                                    formControlName="companyName" class="form-control"
                                                                    placeholder="Enter your company name" [(ngModel)]="requestXplorerRegistration.companyName" />
                                                                <div *ngIf="companyName.invalid && (companyName.dirty || companyName.touched)"
                                                                    class="error">
                                                                    Company Name is required.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="designation">Designation</label>
                                                                <input id="designation" type="text"
                                                                    formControlName="designation" class="form-control" [(ngModel)]="requestXplorerRegistration.designation"
                                                                    placeholder="Enter your designation" />
                                                                <div *ngIf="designation.invalid && (designation.dirty || designation.touched)"
                                                                    class="error">
                                                                    Designation is required.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div *ngIf="isOption2">
                                                    <div class="row">
                                                        <!-- Platform and Username in same row -->
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="platform">Platform</label>
                                                                <input id="platform" type="text" formControlName="platform"
                                                                    class="form-control"
                                                                    placeholder="Enter the platform name" [(ngModel)]="requestXplorerRegistration.platform" />
                                                                <div *ngIf="platform.invalid && (platform.dirty || platform.touched)"
                                                                    class="error">
                                                                    Platform is required.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="username">Username</label>
                                                                <input id="username" type="text" formControlName="username"
                                                                    class="form-control" placeholder="Enter your username" [(ngModel)]="requestXplorerRegistration.userName" />
                                                                <div *ngIf="username.invalid && (username.dirty || username.touched)"
                                                                    class="error">
                                                                    Username is required.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Second Row: Preferred Name on Card and Referral Code -->
                                                <div class="row">
                                                    <!-- Preferred Name on Card -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="preferredName">Preferred Name on Card</label>
                                                            <input id="preferredName" type="text"
                                                                formControlName="preferredName" class="form-control"
                                                                placeholder="Enter your preferred name on card" [(ngModel)]="requestXplorerRegistration.preferredName" />
                                                            <div *ngIf="preferredName.invalid && (preferredName.dirty || preferredName.touched)"
                                                                class="error">
                                                                Preferred Name on Card is required.
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Referral Code -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label for="referralCode">Referral Code</label>
                                                            <input id="referralCode" type="text" formControlName="referralCode"
                                                                class="form-control" placeholder="Enter your referral code" [(ngModel)]="requestXplorerRegistration.referralCode" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Submit Button -->
                                                <div class="form-group text-center">
                                                    <button type="submit" [disabled]="registrationForm.invalid" class="btn btn-primary w-25 register-btn">Register</button>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12 text-center member-fee-text"><!-- Exclusively for Early Members: The ₹9,999 Xplorer Card at Zero Fee. --> &nbsp;</div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="explorerStataData?.registrationStatus == 'REGISTERED'">
                                        <div class="col-12">
                                            <!-- <h2 class="reg-form-heading">Exclusive Invite Program</h2> -->
                                        </div>
                                        <div class="col-12">
                                            <div class="card-activate-img text-center">
                                                <img src="assets/images/smartfx-portal-assets/success.gif" style="width: 80px;" />
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <p class="text-center"><b>Your interest in the Xplorer Card has been registered.</b></p>
                                            <p class="text-center">Since Xplorer is an invite-based card, our team will review your application, and if approved, you’ll receive exclusive access details directly on your email.</p>
                                        </div>                                          
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="card">
                                <div class="card-body p-0">
                                    <div class="card-content"> -->
                            <!-- <div class="row">
                                            <div class="col-12 col-md-8 offset-md-2"> -->
                            <!-- </div>
                                        </div> -->
                            <!-- </div>
                                </div>
                            </div> -->
                        </div>

                    </div>
                </div>


                <div class="container-fluid">
                    <h1 class="card-info-heading text-center">Begin Your Journey to Freedom. Exploration. Luxury.</h1>
                    <div class="card-group">
                        <!-- Card 1: Freedom -->
                        <div class="card-container row">
                            <div class="col-12 col-md-4 p-2">
                                <div class="card">
                                    <div class="card-body p-0">
                                <img src="assets/images/smartfx-portal-assets/xplorer-freedom.png" style="width: 100%;" />
                                    <div class="card-content">
                                        <h2>Freedom – Transactions Without Boundaries</h2>
                                        <ul>
                                            <li>True Zero Forex Card</li>
                                            <li>Zero Cross-Currency Fee</li>
                                            <li>Zero Cost on Global Wallet Transfers</li>
                                            <li>Zero ATM Withdrawal Fee</li>
                                            <li>Zero Load/Reload Fee</li>
                                            <li>Zero Cost Cashout</li>
                                            <li>Currency Notes, right at your door</li>
                                        </ul>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 2: Exploration -->
                            <div class="col-12 col-md-4 p-2">
                                <div class="card">
                                    <div class="card-body p-0">
                                        <img src="assets/images/smartfx-portal-assets/xplorer-terms.png"
                                            style="width: 100%;" />
                                        <div class="card-content">
                                            <h2>Exploration—Your Transit. Your Terms</h2>
                                            <ul>
                                                <li>Global airport lounge access</li>
                                                <li>Airport transit hotels</li>
                                                <li>Meet & Assist for Senior Citizens & Events</li>
                                                <li>Excess baggage support & Wrapping</li>
                                                <li>Visa application at doorstep</li>
                                                <li>Lounges at visa application centre</li>
                                                <li>Global SIM</li>
                                                <li>Instant Travel Insurance</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 3: Luxury -->
                            <div class="col-12 col-md-4 p-2">
                                <div class="card">
                                    <div class="card-body p-0">
                                        <img src="assets/images/smartfx-portal-assets/xplorer-luxury.png"
                                            style="width: 100%;" />
                                        <div class="card-content">
                                            <h2>Luxury - Experiences that Belongs to You</h2>
                                            <ul>
                                                <li>Global Club access and curated spaces</li>
                                                <li>Golf Club Access</li>
                                                <li>Airport Spas indulgences</li>
                                                <li>Airport Food & Beverages</li>
                                                <li>Valet parking at premium touchpoints</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>



<div class="custom-modal-backdrop" *ngIf="showPopup">
  <div class="custom-modal">
    <!-- Header Row -->
    <div class="modal-header-custom">
      <h4 class="xp-modal-title">Welcome to the Explorer Club</h4>
      <button type="button" class="close-btn" (click)="closePopup()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body-custom">
      <div class="popup-image">
        <img src="/assets/images/xplorerCard/xp-sucess-popup.png" alt="Success" />
      </div>

      <p class="main-text">Your interest in the Xplorer Card has been registered.</p>
      <!-- <p class="sub-text">
        Since Xplorer is an invite-based card, our team will review your application, and if approved,
        you’ll receive exclusive access details directly on your email.
      </p> -->
    </div>
  </div>
</div>





